export const FleetManagement_SEO = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.canvendor.com/industries/fleetManagement",
      name: "Fleet Management Software | Canvendor",
      url: "https://www.canvendor.com/industries/fleetManagement",
      description:
        "Simplify your fleet operations with Canvendor's fleet management software. Enjoy real-time GPS tracking, fuel optimization, driver monitoring, and maintenance alerts — all designed to reduce costs and boost efficiency.",
      image: "https://www.canvendor.com/IndustryImages/bannerImg.png",
      datePublished: "2024-09-15",
      dateModified: "2025-10-15",
      publisher: {
        "@id": "https://www.canvendor.com/#organization",
      },
      mainEntity: {
        "@id": "https://www.canvendor.com/industries/fleetManagement#software",
      },
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://www.canvendor.com/industries/fleetManagement#software",
      name: "Canvendor Fleet Management Software",
      operatingSystem: "Web, Android, iOS",
      applicationCategory: "BusinessApplication",
      softwareVersion: "v3.2.1",
      inLanguage: "en",
      description:
        "Canvendor Fleet Management Software provides real-time GPS tracking, fuel optimization, driver monitoring, and maintenance alerts to streamline fleet operations and boost efficiency.",
      url: "https://www.canvendor.com/industries/fleetManagement",
      image: [
        "https://www.canvendor.com/IndustryImages/bannerImg.png",
        "https://www.canvendor.com/images/fleet-dashboard-screenshot1.png",
        "https://www.canvendor.com/images/fleet-tracking-app.png",
      ],
      creator: {
        "@id": "https://www.canvendor.com/#organization",
      },
      publisher: {
        "@id": "https://www.canvendor.com/#organization",
      },
      featureList: [
        "Real-time GPS tracking",
        "Fuel optimization with digital fuel cards",
        "Driver behavior monitoring",
        "Maintenance alerts and reminders",
        "Delivery scheduling optimization",
        "Smart route deviation alerts",
        "Cost optimization analytics",
        "Mobile fleet management app",
        "Compliance and regulation tracking",
        "Geofencing and live incident alerts",
      ],
    },
    {
      "@type": "Organization",
      "@id": "https://www.canvendor.com/#organization",
      name: "Canvendor",
      url: "https://www.canvendor.com",
      logo: "https://www.canvendor.com/assets/images/canvendor-logo.png",
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "Customer Support",
          email: "support@canvendor.com",
          telephone: "+1-800-555-0199",
          availableLanguage: "English",
        },
        {
          "@type": "ContactPoint",
          contactType: "Sales",
          email: "sales@canvendor.com",
          telephone: "+1-800-555-0200",
          availableLanguage: "English",
        },
      ],
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.canvendor.com/industries/fleetManagement#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.canvendor.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Industries",
          item: "https://www.canvendor.com/industries",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Fleet Management",
        },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": "https://www.canvendor.com/industries/fleetManagement#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What are the benefits of using fleet management software?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Fleet management software improves efficiency, reduces fuel and maintenance costs, enhances driver safety, and ensures compliance with regulations, leading to better operational control and cost savings.",
          },
        },
        {
          "@type": "Question",
          name: "How does GPS vehicle tracking improve fleet management?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "GPS tracking provides real-time visibility into vehicle location, routes, and stops, helping optimize routes, reduce fuel consumption, and improve driver accountability.",
          },
        },
        {
          "@type": "Question",
          name: "Can digital fuel cards help reduce fuel expenses?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, digital fuel cards integrated with fleet management software enable smart tracking of fuel usage, preventing fraud and identifying opportunities to cut fuel waste.",
          },
        },
        {
          "@type": "Question",
          name: "Is Canvendor's fleet management solution scalable?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Canvendor's platform is designed to support fleets of all sizes, from small businesses with a few vehicles to large enterprises operating in thousands.",
          },
        },
        {
          "@type": "Question",
          name: "How can I get in touch about Canvendor's fleet management software?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can get in touch with us through our website contact form or by reaching out to our sales team directly via email or phone.",
          },
        },
      ],
    },
  ],
};

export const AIML_SEO = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "Canvendor",
      url: "https://www.canvendor.com",
      logo: "https://www.canvendor.com/assets/images/canvendor_logo.jpg",
      description:
        "Enterprise AI/ML solutions for predictive analytics, intelligent automation, and digital transformation",
      sameAs: [
        "https://www.linkedin.com/company/canvendor",
        "https://twitter.com/Canvendor",
      ],
    },
    {
      "@type": "Product",
      name: "Enterprise AI/ML Solutions",
      description:
        "Scalable, compliant AI/ML platform with predictive analytics, intelligent automation, and no-code deployment for enterprises",
      brand: {
        "@type": "Brand",
        name: "Canvendor",
      },
      offers: {
        "@type": "AggregateOffer",
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        ratingCount: "150",
      },
    },
    {
      "@type": "Service",
      name: "Enterprise AI/ML Consulting & Implementation",
      description:
        "AI strategy, implementation, and modernization services for healthcare, finance, retail, and enterprise sectors",
      provider: {
        "@type": "Organization",
        name: "Canvendor",
      },
      areaServed: "Worldwide",
      serviceType: [
        "AI Consulting",
        "ML Implementation",
        "Predictive Analytics",
        "Workflow Automation",
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How can AI/ML improve enterprise operational efficiency?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "AI/ML improves enterprise efficiency through automated workflow processes, predictive analytics for decision-making, intelligent data processing, and 24/7 automated operations. Canvendor's solutions deliver 70% faster turnaround times and 99% accuracy while reducing manual work across departments through AI-powered automation and cross-departmental integration.",
          },
        },
        {
          "@type": "Question",
          name: "What are the costs and ROI of enterprise AI solutions?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Enterprise AI costs vary by implementation scope, but ROI typically includes reduced operational costs, increased efficiency, improved accuracy, and faster decision-making. Benefits include 70% faster turnaround times, 99% accuracy in automated processes, 24/7 operational capabilities, and significant reduction in manual labor. ROI modeling and strategy definition are included in Canvendor's AI/ML consulting services.",
          },
        },
        {
          "@type": "Question",
          name: "Is enterprise AI compliant with HIPAA and GDPR regulations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, enterprise AI solutions can be fully compliant with HIPAA, GDPR, and SOC 2 regulations. Canvendor provides regulatory-compliant AI platforms with audit-ready logs, encrypted data processing, secure cloud infrastructure, and compliance-ready solutions specifically designed for healthcare, finance, and other regulated industries requiring strict data protection standards.",
          },
        },
        {
          "@type": "Question",
          name: "How does AI integrate with existing ERP and CRM systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "AI integration with ERP and CRM systems occurs through API connections, middleware platforms, and cloud-based integration tools that enable seamless data flow between legacy systems and modern AI platforms. This integration allows enterprises to modernize operations without replacing existing infrastructure while adding intelligent automation, predictive analytics, and automated workflow capabilities.",
          },
        },
        {
          "@type": "Question",
          name: "How long does AI/ML implementation take for enterprises?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "AI/ML implementation timelines vary based on scope and complexity, but no-code and low-code platforms enable rapid deployment within weeks rather than months. Canvendor's enterprise AI solutions offer 70% faster turnaround through scalable deployment strategies, pre-configured industry templates, and streamlined integration processes that minimize disruption to existing operations.",
          },
        },
        {
          "@type": "Question",
          name: "What is Agentic AI for enterprise decision-making?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Agentic AI refers to autonomous artificial intelligence systems that can make independent decisions, take actions, and adapt to changing conditions without constant human intervention. In enterprise contexts, Agentic AI powers next-generation decision-making by analyzing complex data patterns, executing automated workflows, and optimizing business processes in real-time across multiple departments.",
          },
        },
      ],
    },
  ],
};

export const HealthCare_SEO = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is Agentic AI Healthcare Claims Automation?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Agentic AI Healthcare Claims Automation is Canvendor’s next-generation platform that streamlines medical billing and claims processing using artificial intelligence. It automates every step—from claim submission to settlement—ensuring faster reimbursements, higher accuracy, and full HIPAA, GDPR, and SOC 2 compliance.",
      },
    },
    {
      "@type": "Question",
      name: "How does AI improve healthcare claims processing?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "AI improves healthcare claims processing by automating data entry, validating medical codes, and identifying discrepancies in real time. With natural language understanding (NLU) and predictive analytics, Agentic AI minimizes human errors, accelerates approval times, and enhances compliance with healthcare regulations.",
      },
    },
    {
      "@type": "Question",
      name: "What are the key benefits of using Canvendor’s Agentic AI for healthcare providers?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Healthcare providers using Canvendor’s Agentic AI experience up to 70% faster claim processing, 99% accuracy in data validation, reduced denials through predictive prevention, seamless EHR integration, and significant cost savings with improved revenue cycle management.",
      },
    },
    {
      "@type": "Question",
      name: "Is Canvendor’s healthcare claims automation software secure and compliant?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Absolutely. Canvendor’s healthcare claims automation software is fully HIPAA, GDPR, and SOC 2 certified, ensuring top-tier security for sensitive patient and billing data. Every transaction is encrypted, every action logged, and every audit report instantly accessible.",
      },
    },
    {
      "@type": "Question",
      name: "How can I get started with Agentic AI healthcare claims automation?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Getting started is simple. Schedule a personalized demo or request a free consultation with Canvendor’s experts to explore how Agentic AI can modernize your healthcare claims processing, boost compliance, and reduce operational costs.",
      },
    },
  ],
};

export const Home_SEO = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Canvendor Software Solutions Pvt. Ltd.",
  url: "https://www.canvendor.com/",
  logo: "https://www.canvendor.com/images/canvendor-logo.png",
  foundingDate: "2015-01-01",
  founders: [
    {
      "@type": "Person",
      name: "Sanal [Founder/CEO]",
    },
  ],
  sameAs: [
    "https://www.linkedin.com/company/canvendor",
    "https://twitter.com/canvendor",
    "https://www.facebook.com/canvendor",
    "https://www.instagram.com/canvendor",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "Customer Service",
    areaServed: "Worldwide",
    availableLanguage: ["English", "Hindi"],
    url: "https://www.canvendor.com/contact",
    email: "support@canvendor.com",
  },
  address: {
    "@type": "PostalAddress",
    name: "CANVENDOR SOFTWARE SOLUTIONS PRIVATE LIMITED",
    streetAddress: "19/3 PRK Square, Court Road",
    addressLocality: "Nagercoil",
    addressRegion: "Tamil Nadu",
    postalCode: "629001",
    addressCountry: "IN",
  },
};

export const blogJsonLd = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline:
    "How Agentic AI Will Transform Healthcare Claims Automation in 2026 and Beyond",
  description:
    "Explore how Agentic AI is transforming healthcare claims automation in 2026 and beyond, helping providers reduce denials, accelerate reimbursements, and improve compliance.",
  image:
    "https://www.canvendor.com/assets/images/blogs/agentic-ai-healthcare-claims-automation.jpg",
  author: {
    "@type": "Organization",
    name: "Canvendor Technologies",
  },
  publisher: {
    "@type": "Organization",
    name: "Canvendor",
    logo: {
      "@type": "ImageObject",
      url: "https://www.canvendor.com/images/canvendor-logo.png",
    },
  },
  url: "https://www.canvendor.com/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026",
  datePublished: "2025-10-28",
  dateModified: "2025-10-28",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id":
      "https://www.canvendor.com/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026",
  },
};

export const AgenticAiBlog = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: "Agentic AI Automation for QA: Realistic ROI & Cost Savings",
  description:
    "Agentic AI automation delivers 20–35% QA cost reduction in the first year through self-healing tests and low-code creation. This article explains realistic benefits, limitations, and success factors.",
  image: "https://www.canvendor.com/BlogImages/blogBannerImage2.jpg",
  author: { "@type": "Organization", name: "Canvendor Technologies" },
  publisher: {
    "@type": "Organization",
    name: "Canvendor",
    logo: {
      "@type": "ImageObject",
      url: "https://www.canvendor.com/images/canvendor-logo.png",
      width: 250,
      height: 60,
    },
    sameAs: [
      "https://www.linkedin.com/company/canvendor",
      "https://twitter.com/CanvendorTech",
    ],
  },
  url: "https://www.canvendor.com/blog/agentic-ai-automation-qa-realistic-roi",
  datePublished: "2025-11-06",
  dateModified: "2025-11-06",
  keywords: "test automation, agentic AI, QA automation, self-healing tests",
  articleSection: "QA & Testing",
  wordCount: 2400,
  timeRequired: "PT10M",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id":
      "https://www.canvendor.com/blog/agentic-ai-automation-qa-realistic-roi",
  },
};
